import Column from '@components/Column';
import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import SignUpButton from './components/SignUpButton';
import SignUpForm from './components/SignUpForm';
import SignUpContextProvider from './context/SignUpContextProvider';

interface Params {
    appleId?: string;
    googleId?: string;
    kakaoId?: number;
    nickname?: string;
}

const SignUpActivity: ActivityComponentType<Params> = ({ params }:{params:Params }) => {
    const { t } = useTranslation('signUp');
    const {
        appleId, kakaoId, nickname, googleId,
    } = params;
    return (
        <SignUpContextProvider appleId={appleId}
            googleId={googleId}
            kakaoId={kakaoId}
            nickname={nickname} >
            <AppScreen>
                <Column fullWidth fullHeight>
                    <Header title={t('header')} />
                    <SignUpForm/>
                    <SignUpButton/>
                </Column>
            </AppScreen>
        </SignUpContextProvider>
    );
};

export default SignUpActivity;
